window.xFpApplyBleed = window.xFpApplyBleed || function (id) {
  var wrap = document.getElementById('x-flavor-picker-' + id);
  var track = document.getElementById('x-product-complementary-' + id);
  if (!wrap || !track) return;
  var gutter = window.innerWidth >= 1024 ? 24 : 16;
  var rtl = getComputedStyle(document.documentElement).direction === 'rtl';
  var rect = wrap.getBoundingClientRect();
  var gap = rtl ? rect.left : window.innerWidth - rect.right;
  var extend = Math.min(Math.max(Math.round(gap), 0), window.innerWidth);
  track.style.marginInlineEnd = '-' + extend + 'px';
  track.style.paddingInlineEnd = gutter + 'px';
  if (!wrap.dataset.bleedBound) {
    wrap.dataset.bleedBound = '1';
    window.addEventListener('resize', function () {
      window.xFpApplyBleed(id);
    });
  }
};